import {Stack, styled} from '@mui/material';

export const StyledFooterContainer = styled(Stack)`
	flex-direction: row;
	padding: 16px 24px;
	border-radius: 8px;
	background-color: ${({theme}) => theme.palette.background.paper};
	justify-content: space-between;
	gap: 16px;
`;
